import React from 'react';

export default function ClientRender({ children }) {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? children : null;
}



// WEBPACK FOOTER //
// ./components/clientRender/ClientRender.js